import React from 'react';
import styled from 'styled-components';
import { I18n } from '@aws-amplify/core';

const Title = styled.h2`
	font-size: 36px;
	color: ${({ theme }) => theme.palette.secondary['400']};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_3xl};
`;

export function Header(): JSX.Element {
	return <Title>{I18n.get('Resolution 886')}</Title>;
}
